jQuery(function() {
    //IE11 Detection
    var IE11 = !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/));;
    if(IE11 === true){
        $('html').addClass('IE11');
    }

    //Product Page Item description collapse and tabs
    $(function () {
        $("#tabs > div").hide();
        $("#tabs > div:first").show();
        $("#tabs > span.tab-buttons button:first").addClass("active");
        $("#tabs > span.tab-buttons button").on("click", function () {
        $("#tabs > span.tab-buttons button").attr("class", "");
        $("#tabs > span.tab-buttons button").attr("tabindex", "-1");
        $("#tabs > span.tab-buttons button").attr("aria-selected", "false");
        $(this).attr("class", "active");
        $(this).attr("tabindex", "0");
        $(this).attr("aria-selected", "true");
        var currentTab = $(this).attr("aria-controls");
        $("#tabs > div").hide();
        $(`#${currentTab}`).show();
        return false;
        });
    });
    $(window).on('load', function () {
        $('.item-image, .slider').flexslider({
            animation: "slide",
            animationLoop: false,
            useCSS: false
        });
    });
    /*Pinned Header */
    checkOffset();
    $(window).on('scroll', function() {
        checkOffset();
    });
    function checkOffset() {
        if ( window.scrollY > 0){
            $('header').addClass('fixed');
        } else {
            $('header').removeClass('fixed');
        }
        if (document.body.classList.contains("pgcheckout")) {
            var payNow = document.getElementById('pay-now');
            if( payNow != null || payNow != undefined ){
                var checkoutbuttontop = $('#pay-now').offset().top;
                var viewportWidth = document.documentElement.clientWidth;
                var scrollBottom = $(window).scrollTop() + $(window).height();
                if (viewportWidth < 768 && scrollBottom < checkoutbuttontop) {
                    $('#btn-fixed-wrapper').addClass('fixed');
                } else {
                    $('#btn-fixed-wrapper').removeClass('fixed');
                }
            }
        }
    }

    // ADA AAA
    var $dropdowns = $("#main-nav .dropdown");
    var $dropdownsLinks = $("#main-nav .dropdownLink");
    $dropdownsLinks.on("focus",function(){
        let $thisParent = $(this).parent();
        $dropdowns.removeClass("open");
        $dropdownsLinks.attr("aria-expanded", "false");
        $thisParent.addClass("open");
        $(this).attr("aria-expanded", "true");
    })
    $('.menu-overlay').on("focusout", function() {
        setTimeout(() => {
            // if active element is outside the div.menu-overlay...
            if ($(document.activeElement).parents('.menu-overlay').length === 0) {
            // remove hover functionality
                $dropdowns.removeClass("open");
            }
        }, 100)
    })
    let fitstNavChild = $("#main-nav .dropdownLink").first()[0];
    $(fitstNavChild).on("keydown", function(e) {
        if(e.key === 'Tab' && e.shiftKey) {
            $dropdowns.removeClass("open");
            $dropdownsLinks.attr("aria-expanded", "false");
        }
    })
    let lastNavChild = $("#main-nav .dropdownLink").last()[0];
    $(lastNavChild).on("keydown", function(e) {
        if(e.key === 'Tab') {
            $dropdowns.removeClass("open");
            $dropdownsLinks.attr("aria-expanded", "false");
        }
    })
    if (document.body.classList.contains("pghome")) {
        //Bedding section swiper tabs
        $(function () {
            $("#bedding-swiper-selector > div").hide();
            $("#bedding-swiper-selector > div:first").show();
            $("#bedding-swiper-selector > span.hp-bedding-navigation button:first").addClass("active");
            $("#bedding-swiper-selector > span.hp-bedding-navigation button").on("click", function () {
                $("#bedding-swiper-selector > span.hp-bedding-navigation button").attr("class", "");
                $("#bedding-swiper-selector > span.hp-bedding-navigation button").attr("tabindex", "-1");
                $("#bedding-swiper-selector > span.hp-bedding-navigation button").attr("aria-selected", "false");
                $(this).attr("class", "active");
                $(this).attr("tabindex", "0");
                $(this).attr("aria-selected", "true");
                var beddingcurrentTab = $(this).attr("aria-controls");
                $("#bedding-swiper-selector > div").hide();
                $(`#${beddingcurrentTab}`).show();
                return false;
            });
        });
        $(function () {
            $('[id^="fragrance-slide-"]').each(function(index) {
                $(this).on("mouseenter", function () {
                    swiperfragrancetext.slideTo(index);
                    swiperfragranceimg.slideTo(index);
                });
            });
        });
        function checkWidth() {
            var viewportWidth = document.documentElement.clientWidth;
            if (viewportWidth < 768) {
                
            } else {
                
            } 
        }
        checkWidth();
        window.addEventListener("resize", function(){
            checkWidth();
        });
    } 
}); 




